export default __webpack_public_path__ + "static/media/instagram_logo.f7b3dff3.png";